import { isRtlLanguage } from '../../utils/is-rtl-language';
import { WIX_CHAT } from '@wix/app-definition-ids';
import { parseInstance } from '../../../controller/utils/parse-instance';
export const SET_BASIC_PARAMS = 'SET_BASIC_PARAMS';
export const setBaseParamsSuccess = (payload) => ({
    type: SET_BASIC_PARAMS,
    payload,
});
export const UPDATE_INSTANCE = 'UPDATE_INSTANCE';
export const updateInstance = ({ instance }) => ({
    type: UPDATE_INSTANCE,
    payload: { instance, instanceValues: parseInstance(instance) },
});
export function setBaseParams({ appDefinitionId, language, isSSR, }) {
    return async (dispatch, getState, { wixCodeApi, platformAPIs, instanceManager }) => {
        const viewMode = wixCodeApi.window.viewMode;
        const isMaInstalled = (await Promise.all([
            wixCodeApi.site.isAppSectionInstalled({
                appDefinitionId: '14cffd81-5215-0a7f-22f8-074b0e2401fb',
                sectionId: 'member_info',
            }),
            wixCodeApi.site.isAppSectionInstalled({
                appDefinitionId: 'b976560c-3122-4351-878f-453f337b7245',
                sectionId: 'member_page',
            }),
        ])).some((isInstalled) => isInstalled);
        let biMetadata;
        try {
            biMetadata =
                platformAPIs.bi?.visitorId && platformAPIs.bi?.metaSiteId
                    ? {
                        visitorId: platformAPIs.bi.visitorId,
                        // @ts-expect-error
                        bsi: platformAPIs.biLoggerFactory?.().loggerClientFactory._defaults?.bsi?.(),
                        metaSiteId: platformAPIs.bi.metaSiteId,
                    }
                    : undefined;
        }
        catch (error) { }
        const isChatInstalled = isSSR
            ? false
            : await wixCodeApi.site
                .getPublicAPI(WIX_CHAT)
                .then((api) => Promise.race([
                api.isMembersChatEnabled(),
                new Promise((res) => setTimeout(() => res(false), 500)),
            ]))
                .catch(() => false);
        return dispatch(setBaseParamsSuccess({
            viewMode,
            formFactor: wixCodeApi.window.formFactor,
            instance: instanceManager.getInstance(),
            instanceValues: instanceManager.getInstanceValues(),
            isSSR: wixCodeApi.window.rendering.env === 'backend',
            isSeo: wixCodeApi.seo.isInSEO(),
            language,
            isDebug: !!wixCodeApi.location.query.debug,
            isProduction: process.env.NODE_ENV === 'production',
            // @ts-expect-error: Incorrect platformAPIs typing
            pageNumber: platformAPIs.bi.pageNumber,
            appDefinitionId,
            isRTL: isRtlLanguage(language),
            isMaInstalled,
            isChatInstalled,
            biMetadata,
        }));
    };
}
//# sourceMappingURL=base-params-actions.js.map